"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = exports.getValidRepurchase = exports.getValidRVRange = void 0;
const getValidRVRange = (period) => {
    if (period === 24)
        return [19, 55];
    if (period === 36)
        return [1, 50];
    if (period === 48)
        return [1, 40];
    if (period === 60)
        return [1, 30];
    if (period === 72)
        return [1, 20];
    return [1, 1];
};
exports.getValidRVRange = getValidRVRange;
const getValidRepurchase = (period, repurchase) => {
    const maxRV = (0, exports.getValidRVRange)(period);
    if (repurchase < maxRV[0])
        return maxRV[0];
    if (repurchase > maxRV[1])
        return maxRV[1];
    return repurchase;
};
exports.getValidRepurchase = getValidRepurchase;
const formatPrice = (number) => {
    if (!number)
        return "";
    const maximumFractionDigits = `${number}`.includes(".") ? 2 : 0;
    return new Intl.NumberFormat("pl-PL", {
        style: "decimal",
        maximumFractionDigits: maximumFractionDigits,
        minimumFractionDigits: maximumFractionDigits
    })
        // @ts-ignore
        .format(number.toFixed(2));
};
exports.formatPrice = formatPrice;
//# sourceMappingURL=index.js.map